

<app-header-auth></app-header-auth>
<div class="m-auto container text-center">
    <div class="card login-form border-0 bg-none m-auto">
      
      <div class="card-header border-0 bg-none mt-3">
        <h4 class="text-center"> {{'RESETPASS' | translate}}</h4>
        <span class="text-danger" *ngIf="this.admin.error?.error?.nouser">{{this.admin.error?.error?.nouser}}</span>
      </div>
      
      <div class="card-body p-0">

        <form [formGroup]="validateForm" class="login-form" (ngSubmit)="submitForm()">

          <div class="form-floating mb-3">
            <input
              [ngClass]="{'is-invalid': error}"
              type="text"
              class="form-control"
              formControlName="email"
              id="email"
              placeholder="{{ 'EMAIL' | translate }}" required>
            <label for="email">{{ 'EMAIL' | translate }}</label>
            <div class="invalid-feedback">
              {{error}}
            </div>
          </div>
          
          <div class="form-floating mb-3">
            <button
              class="btn btn-lg w-100 btn-primary rounded-3"
              [disabled]="!validateForm.valid || load">
              <span *ngIf="load" class="spinner-border spinner-border-sm" role="status" ></span>
              {{ 'RESETPASS' | translate }}
            </button>
          </div>
        </form>

        <div class="d-flex align-items-center justify-content-center mt-2">
            <a  routerLink="/signin"  >{{ 'SIGNIN' | translate }}</a>
        </div>


      </div>

    </div>
</div>

  